import Grid from '@material-ui/core/Grid'
import Image from 'next/legacy/image'
import styled from 'styled-components'
import { CreditUnionIcon } from '../icon/CreditUnionIcon'

export const StyledCarouselImageWrapper = styled(Grid)`
  width: 100%;
  margin: 0 ${props => props.theme.typography.pxToRem(20)};
  height: ${props => props.theme.typography.pxToRem(250)};

  ${props => props.theme.breakpoints.up('sm')} {
    margin: 0;
    height: ${props => props.theme.typography.pxToRem(480)};
  }

  ${props => props.theme.breakpoints.up('md')} {
    height: ${props => props.theme.typography.pxToRem(540)};
  }

  ${props => props.theme.breakpoints.up('lg')} {
    height: ${props => props.theme.typography.pxToRem(655)};
  }
`

export const StyledImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const StyledImage = styled(Image)`
  position: relative;
  display: inline-block;
  width: 100%;
  clip-path: polygon(95% 0, 100% 23%, 100% 100%, 0 100%, 0 0);

  ${props => props.theme.breakpoints.up('sm')} {
    clip-path: polygon(95.5% 0, 100% 19%, 100% 100%, 0 100%, 0 0);
  }

  ${props => props.theme.breakpoints.up('md')} {
    clip-path: polygon(94% 0, 100% 23%, 100% 100%, 0 100%, 0 0);
  }
`

export const StyledNewsCardDoubleTriangle = styled.div`
  z-index: -1;
  position: absolute;
  top: -${props => props.theme.typography.pxToRem(15)};
  right: -${props => props.theme.typography.pxToRem(24)};
  height: 100px;
  width: 100px;

  ${props => props.theme.breakpoints.up('sm')} {
    top: -${props => props.theme.typography.pxToRem(7)};
    right: -${props => props.theme.typography.pxToRem(32)};
    height: 100px;
    width: 100px;
  }

  ${props => props.theme.breakpoints.up('md')} {
    top: -${props => props.theme.typography.pxToRem(15)};
    right: -${props => props.theme.typography.pxToRem(47)};
    height: 150px;
    width: 150px;
  }

  ${props => props.theme.breakpoints.up('lg')} {
    top: -${props => props.theme.typography.pxToRem(15)};
    right: -${props => props.theme.typography.pxToRem(55)};
    height: 200px;
    width: 200px;
  }

`

export const StyledNewsCardTriangle = styled(CreditUnionIcon)`
  position: absolute;
  top: -${props => props.theme.typography.pxToRem(30)};
  left: ${props => props.theme.typography.pxToRem(48)};

  ${props => props.theme.breakpoints.up('md')} {
    top: -${props => props.theme.typography.pxToRem(46)};
    left: ${props => props.theme.typography.pxToRem(56)};
  }
`
